import { ICanvasElementDrawArgs } from './canvas';
import { IMarketingCenterFormat, EMarketingCenterFormats } from './format';
import { EMarketingCenterColorSchemes } from './colorScheme';
import {
  BirthdayTemplate,
  CustomTemplate,
  GiftTemplate,
  HelloTemplate,
  LoyaltyTemplate,
  OfferTemplate
} from './templates';

export enum EMarketingCenterTemplates {
  LOYALTY = 'loyalty-template',
  OFFER = 'offer-template',
  BIRTHDAY = 'birthday-template',
  GIFT = 'gift-template'
}

export interface IMarketingCenterTemplate {
  tag: string;
  title: string;
  description: string;
  disabledDescription?: string;
  button?: {
    label: string;
    link: string;
  };
  placeholders: {
    title: string;
    text: string;
    colorScheme?: EMarketingCenterColorSchemes;
    titleMaxLength?: number;
    textMaxLength?: number;
  };
  form?: {
    hideMessageField?: boolean;
    textFieldAsTextArea?: boolean;
  };
  formats: IMarketingCenterFormat[];
}

export async function draw(
  context: CanvasRenderingContext2D,
  template: IMarketingCenterTemplate,
  formatKey: EMarketingCenterFormats,
  args: ICanvasElementDrawArgs,
  isPreview: boolean = false
) {
  const format = template.formats.find(format => format.key === formatKey);
  if (!format) return;

  for (const element of format.elements) {
    if ((isPreview && element.showOnPreview) || !isPreview) {
      await element.draw(context, args);
    }
  }
}

export async function render(
  container: HTMLDivElement,
  context: CanvasRenderingContext2D,
  template: IMarketingCenterTemplate,
  formatKey: EMarketingCenterFormats,
  args: ICanvasElementDrawArgs
) {
  const format = template.formats.find(format => format.key === formatKey);
  if (!format) return;

  for (const element of format.elements) {
    if (element.render) {
      element.render(container, context, args);
    }
  }
}

export const TemplatesDictionary: Record<
  EMarketingCenterTemplates,
  IMarketingCenterTemplate
> = {
  [EMarketingCenterTemplates.LOYALTY]: LoyaltyTemplate,
  [EMarketingCenterTemplates.OFFER]: OfferTemplate,
  [EMarketingCenterTemplates.BIRTHDAY]: BirthdayTemplate,
  [EMarketingCenterTemplates.GIFT]: GiftTemplate
};
